import React from "react";
import check from "../../icons/icon_check.svg";
import aboutcontent from "../../images/about/about-content.svg";
const SolutionSection = () => {
  return (
    <section className="problem_solution_section section_space pb-0">
      <div className="container">
        <div
          className="ico_heading_block text-center"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="heading_text mb-0">
                Start collecting today, look for shops with the TopCoin UK sticker
              </h2>
            </div>
          </div>
        </div>

        <div
          className="ico_problem_solution_table mb-3"
          data-aos="fade-up"
          data-aos-duration="600"
          data-aos-delay="100"
        >
          <div className="column_wrapper">
            {/* ICO Problem Section */}
            <div className="column_problem">
              <h3 className="heading_text mb-4">
                {/* <span className="icon">
                  <img src={sIcon1} alt="Icon Man With Question" />
                </span> */}
                <span className="text text-dark">For Customers</span>
              </h3>
              <ul className="iconlist_block unordered_list_block">
                {[
                  {
                    label:
                      // "Earn TopCoin automatically when you make purchases.",
                      "Earn TopCoin automatically when you shop with participating businesses.",
                  },
                  {
                    label:
                      // "TopCoin are free, never expire, and unlock greater benefits as you collect more.",
                      "TopCoin units are issued free of charge, do not expire under programme rules, and may unlock additional promotional benefits as you collect more.TopCoin are free, never expire, and unlock greater benefits as you collect more.",
                  },
                  {
                    label:
                      // "Unlock customer wallets as you collect more TopCoin.",
                      "Unlock customer reward wallets as you reach defined TopCoin milestones.",
                  },
                  {
                    // label: "Receive cash rewards from company-funded reward wallets.",
                    label: "Eligible customers may receive promotional reward allocations funded by participating businesses, subject to programme terms.",
                  },
                  {
                    // label: "No investment. No risk. Just rewards.",
                    label: "TopCoin UK operates as a loyalty and promotional rewards platform.",
                  },
                  {
                    // label: "Holding TopCoin is not an investment and does not involve staking, speculation, or financial risk.",
                    label: "Holding TopCoin is not an investment. TopCoin does not earn interest and does not represent equity, ownership, or financial returns.",
                  },
                  {
                    // label: "TopCoin cannot be purchased and are only earned through normal shopping activity.",
                    label: "TopCoin cannot be purchased and is only issued through normal shopping activity with participating retailers.",
                  },
                ].map((item, index) => (
                  <li key={index}>
                    <span className="iconlist_icon">
                      <img src={check} alt="Icon Check" />
                    </span>
                    <span className="iconlist_label">
                      {item.label}
                      {/* <small className="iconlist_info">{item.info}</small> */}
                    </span>
                  </li>
                ))}
              </ul>
              <p className="mt-3 text-dark fw-bold opacity-50">
                {/* Start collecting today, look for shops with the TopCoin UK sticker */}
                TopCoin UK is a loyalty and promotional rewards programme. It does not provide financial services, investments, or payment products.
              </p>
            </div>

            {/* ICO Solution Section */}
            <div className="column_solution justify-content-center text-center">
              <div className="row align-items-center justify-content-center">
                <div className="column_problem">
                  <img src={aboutcontent} className="px-lg-5" alt="About" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
